// src/admin/OrganizationManagement.js
import React, { useState, useEffect } from 'react';
import { PageHeader, PageDescription } from '../main/LayoutStyles';
import { StyledButton, AlertBox, Card } from '../main/CommonStyles';
import apiClient from '../services/api';
import { Loader2, AlertTriangle, PlusCircle, Building } from 'lucide-react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const OrgList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const OrgCard = styled(Link)`
    display: block;
    text-decoration: none;
    color: inherit;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

    &:hover {
        text-decoration: none;
        transform: translateY(-3px);
        box-shadow: ${({ theme }) => theme.shadows.lg};
    }
`;

const OrganizationManagement = () => {
    const [orgs, setOrgs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchOrgs = async () => {
            try {
                const response = await apiClient.get('/organizations');
                setOrgs(response.data);
            } catch (err) { setError('Błąd ładowania organizacji.'); }
            finally { setLoading(false); }
        };
        fetchOrgs();
    }, []);

    if (loading) return <div style={{textAlign: 'center', padding: '2rem'}}><Loader2 className="icon-spin" /></div>;
    if (error) return <AlertBox type="error"><AlertTriangle/> {error}</AlertBox>;

    return (
        <div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem'}}>
                <PageHeader style={{margin: 0}}>Zarządzanie Organizacjami</PageHeader>
                {/* TODO: Dodać logikę formularza dodawania nowej organizacji */}
                <StyledButton><PlusCircle size={16}/> Dodaj Organizację</StyledButton>
            </div>
            <PageDescription>Kliknij na organizację, aby zarządzać jej personelem, menedżerami i grupami.</PageDescription>

            <OrgList>
                {orgs.map(org => (
                    // **KLUCZOWA POPRAWKA JEST TUTAJ**
                    // Zmieniono ścieżkę z 'admin-panel' na 'system-admin-panel'
                    <OrgCard to={`/app/system-admin-panel/organization/${org.id}`} key={org.id}>
                        <Card style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                            <Building size={32} />
                            <div>
                                <h3 style={{margin: 0, fontSize: '1.2rem'}}>{org.name}</h3>
                                <p style={{margin: 0, color: '#666'}}>{org.city}</p>
                            </div>
                        </Card>
                    </OrgCard>
                ))}
            </OrgList>
        </div>
    );
};

export default OrganizationManagement;